<script setup lang="ts">
import { TooltipArrow, TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from 'reka-ui'

/**
 * Tooltip — výhradne doplnková informácia.
 *
 * Kritické údaje (cena, dôvod nedostupnosti, chyba) sa za hover neschovávajú;
 * tooltip nesie napr. celý názov zbaleného menu v úzkom raile.
 */
withDefaults(
	defineProps<{
		contentSk: string
		side?: 'top' | 'right' | 'bottom' | 'left'
		/** Predvolených 300 ms: kratšie okno bliká pri prechode myšou cez ikony. */
		delayMs?: number
	}>(),
	{ side: 'right', delayMs: 300 },
)
</script>

<template>
	<TooltipRoot :delay-duration="delayMs">
		<TooltipTrigger as-child>
			<slot />
		</TooltipTrigger>
		<TooltipPortal>
			<TooltipContent
				:side="side"
				:side-offset="6"
				class="z-(--z-dropdown) max-w-64 rounded-md bg-fg px-2 py-1 text-xs text-bg shadow-md"
			>
				{{ contentSk }}
				<TooltipArrow class="fill-[var(--color-fg)]" :width="8" :height="4" />
			</TooltipContent>
		</TooltipPortal>
	</TooltipRoot>
</template>
